// extracted by mini-css-extract-plugin
export default {"dokobitContainer":"IdentityGateway_dokobitContainer__7G77C"};